module.exports = __webpack_public_path__ + "img/marine_app_1.b7927586.jpg";